import { CreatedInterfaces } from '../interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'csv-transactions';

const useGetPaymentFile = (
  fileName: string
) => {

  const buildPath = (fileName: String) => {
	return `v2/exporter/files?name=${fileName}&process=SETTLEMENT_PAYMENT_DOMESTIC`
  }

  const [{ data, error, loading: isLoading }, execute] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: buildPath(fileName),
    manual: true,
  });

  return {
    fileUrl: data?.url,
    fileLoading: isLoading,
    isFileError: error,
    execute
  };
}

export default useGetPaymentFile;
